export default __webpack_public_path__ + "static/media/cogollosolo.a646cbc3.png";